document.addEventListener('lazyloaded', function (event)  {
    event.target.parentNode.classList.remove('loading');
});
